<template>
    <Card>
        <Table :columns="table.columns" :url="table.url" v-model:orders="table.orders" :handle="tableHandle">
            <template #td-id="{row}">
                <router-link :to="{ name: 'EditExitDeclarationPage', params: { exitDeclarationUuid: row.uuid } }">{{ row.id }}</router-link>
            </template>
            <template #td-warehouse="{row}">
                {{ row.warehouse.name }}
            </template>
            <template #td-status="{row}">
                <span class="badge" :style="{
                        background: row.status.color,
                        color : 'white'
                    }">{{ row.status.name }}</span>
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
        </Table>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import Table from '../../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../../components/new/table/tableHandle';
import DateFormatter from '../../../../../services/DateFormatter';

export default {
    name: 'ExitDeclarationCard',
    components: {
        Card, Table
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: `/projects/${this.$route.params.projectUuid}/wms/exit-declarations`,
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '100px', type: 'string', order: true},
                    {key: 'warehouse', name: this.$t('table.titles.warehouse'), width: '300px', type: 'string', order: false},
                    {key: 'status', name: this.$t('table.titles.status'), width: '150px', type: 'string', order: false},
                    {key: 'created_at', name: this.$t('table.titles.created_at'), width: '150px', type: 'string', order: true},
                ],
                orders: []
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows({
            extra_fields: ['warehouse', 'exitDeclarationStatus'],
            order_uuids: [this.$route.params.orderUuid]
        })
    }
}
</script>
